export const isProfileComplete = (user) => {
  if (!user) return false;
  if (user.profileComplete === true) return true;
  if (user.profileComplete === false) return false;
  return Boolean(
    user.birthDay &&
      user.birthMonth &&
      user.birthYear &&
      (user.gender === 'm' || user.gender === 'f') &&
      user.countryCode &&
      user.zipCode
  );
};

// RapidoReach wants locale as LANG-CC, e.g. ENG-US. We only store the
// country code, so default the language to ENG.
export const buildRapidoLocale = (user) => {
  const cc = String(user?.countryCode || 'US').toUpperCase();
  return `ENG-${cc}`;
};

// RapidoReach wants YYYY-MM-DD. Returns undefined when incomplete.
export const buildRapidoDOB = (user) => {
  const { birthYear, birthMonth, birthDay } = user || {};
  if (!birthYear || !birthMonth || !birthDay) return undefined;
  const mm = String(birthMonth).padStart(2, '0');
  const dd = String(birthDay).padStart(2, '0');
  return `${birthYear}-${mm}-${dd}`;
};

// RapidoReach wants M/F; we store m/f.
export const buildRapidoGender = (user) => {
  if (user?.gender === 'm') return 'M';
  if (user?.gender === 'f') return 'F';
  return undefined;
};
// Builds the CPX get-surveys.php profiling query string, e.g.
// "&main_info=true&birthday_day=XX&...". Returns '' when the profile
// is incomplete so callers fall back to the untargeted request.
export const buildCpxProfileParams = (user) => {
  if (!isProfileComplete(user)) return '';
  const params = new URLSearchParams({
    main_info: 'true',
    birthday_day: String(user.birthDay),
    birthday_month: String(user.birthMonth),
    birthday_year: String(user.birthYear),
    gender: user.gender,
    user_country_code: user.countryCode,
    zip_code: user.zipCode,
  });
  return `&${params.toString()}`;
};

export const COUNTRY_OPTIONS = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'AU', name: 'Australia' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'ES', name: 'Spain' },
  { code: 'IT', name: 'Italy' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'BE', name: 'Belgium' },
  { code: 'IE', name: 'Ireland' },
  { code: 'SE', name: 'Sweden' },
  { code: 'NO', name: 'Norway' },
  { code: 'DK', name: 'Denmark' },
  { code: 'FI', name: 'Finland' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'AT', name: 'Austria' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'MX', name: 'Mexico' },
  { code: 'BR', name: 'Brazil' },
  { code: 'IN', name: 'India' },
  { code: 'ZA', name: 'South Africa' },
];
